import { createSelector } from "reselect";

const selectAuth = (state) => state.auth;

const selectCognitoUser = () => createSelector(selectAuth, (authState) => authState.cognitoUser);

const selectChallengedUser = () =>
  createSelector(selectAuth, (authState) => authState.challengedUser);

const selectIsLogout = () => createSelector(selectAuth, (authState) => authState.isLogout);

const selectIsLoggedIn = () => createSelector(selectAuth, (authState) => authState.isLoggedIn);

export { selectCognitoUser, selectChallengedUser, selectIsLogout, selectIsLoggedIn };
